module.exports = __webpack_public_path__ + "static/media/7.fd6da9ab.JPG";